import React from "react";
import DocumentPreview from "./DocumentPreview";
import { useGetSMSFilePresignedUrl } from "hooks/api/messages/useGetSMSFilePresigned";
import DocumentUploadDisplay from "./UploadActionDisplay";
import VideoPreview from "./VideoPreview";
import ImagePreview from "./ImagePreview";

const FilePreview = ({
  message,
  renderedInModal = false,
  hasUploadedToClientAccount,
  onIconPress,
}) => {
  const { pkey: messageId, metadata } = message;
  const { fileSize, fileName, fileType } = metadata;
  const { presignedUrl, presignedUrlErr, presignedUrlLoading } =
    useGetSMSFilePresignedUrl(messageId);

  const handleFilePress = () => {
    if (presignedUrl) {
      window.open(presignedUrl, "_blank");
    }
  };

  const isImage = fileType?.startsWith("image/");
  const isVideo = fileType?.startsWith("video/");

  let previewContent;

  if (isVideo && !renderedInModal && !presignedUrlErr) {
    previewContent = <VideoPreview presignedUrl={presignedUrl} handleClick={handleFilePress} />;
  } else if (isImage && !renderedInModal && !presignedUrlErr) {
    previewContent = (
      <ImagePreview presignedUrl={presignedUrl} handleClick={handleFilePress} fileName={fileName} />
    );
  } else {
    previewContent = (
      <DocumentPreview
        presignedUrl={presignedUrl}
        handleClick={handleFilePress}
        renderedInModal={renderedInModal}
        fileSize={fileSize}
        fileName={fileName}
        error={!!presignedUrlErr}
        urlLoading={presignedUrlLoading}
      />
    );
  }

  return (
    <>
      {previewContent}

      {!renderedInModal && !presignedUrlErr && (
        <DocumentUploadDisplay
          onIconPress={() => onIconPress(message)}
          hasUploadedToClientAccount={hasUploadedToClientAccount}
        />
      )}
    </>
  );
};

export default FilePreview;
